import FJCommunityIcon from '../../assets/svg/community/community.svg?react';
import FJHomeIcon from '../../assets/svg/community/home.svg?react';
import FJAiToolsIcon from '../../assets/svg/community/ai-tools.svg?react';
import FJMySpaceIcon from '../../assets/svg/community/my-space.svg?react';
import FJNewestIcon from '../../assets/svg/community/newest.svg?react';
import FJConstant from '../../constants/FJConstant';
import FJConfig from '../FJConfig';
import FJS3Config from '../FJS3Config';
import FJVersionConfig from '../FJVersionConfig';
import FJAppConstant from '../../constants/FJAppConstant';
const aiToolsPreJumpLink = FJConfig.isTest ? '/apply/' : '/ai/';
export const AI_COMMUNITY_TAB_LIST = [
    {
        name: 'home',
        value: FJConstant.HOME,
        icon: FJHomeIcon,
        hrefSuffix: 'home',
    },
    {
        name: 'community',
        value: FJConstant.COMMUNITY,
        icon: FJCommunityIcon,
        hrefSuffix: 'community',
    },
    {
        name: 'ai-tools',
        value: FJConstant.AI_TOOL_LIST,
        icon: FJAiToolsIcon,
        hrefSuffix: 'tools',
    },
    {
        name: 'line',
        value: FJConstant.LINE,
        icon: '',
    },
    {
        name: 'my-space',
        value: FJConstant.MY_SPACE,
        icon: FJMySpaceIcon,
        hrefSuffix: 'space',
    },
];
const simpleToolsSourceBaseUrl = FJConfig.imgPath + 'community/ai-tools/';
export const AI_COMMUNITY_SIMPLE_TOOLS_LIST = [
    {
        name: 'image-to-video',
        desc: 'generate-videos-from-images',
        hoverEffect: 'play video',
        source: {
            normal: simpleToolsSourceBaseUrl + 'image-to-video.png' + '?v=' + FJVersionConfig.staticPathVersion,
            hover: simpleToolsSourceBaseUrl + 'image-to-video.mp4' + '?v=' + FJVersionConfig.staticPathVersion,
        },
        jumpLink: aiToolsPreJumpLink + 'video-generator/image-to-video/',
    },
    {
        name: 'text-to-video',
        desc: 'generate-videos-from-text',
        hoverEffect: 'play video',
        source: {
            normal: simpleToolsSourceBaseUrl + 'text-to-video.png' + '?v=' + FJVersionConfig.staticPathVersion,
            hover: simpleToolsSourceBaseUrl + 'text-to-video.mp4' + '?v=' + FJVersionConfig.staticPathVersion,
        },
        jumpLink: aiToolsPreJumpLink + 'video-generator/text-to-video/',
    },
    {
        name: 'ai-video-effect',
        desc: 'animate-photos-with-viral-effects',
        hoverEffect: 'play video',
        source: {
            normal: simpleToolsSourceBaseUrl + 'video-effect.png' + '?v=' + FJVersionConfig.staticPathVersion,
            hover: simpleToolsSourceBaseUrl + 'video-effect.mp4' + '?v=' + FJVersionConfig.staticPathVersion,
        },
        jumpLink: aiToolsPreJumpLink + 'video-generator/video-effect/',
    },
    {
        name: 'text-to-image',
        desc: 'generate-images-from-text',
        hoverEffect: 'zoom in',
        source: {
            normal: simpleToolsSourceBaseUrl + 'text-to-image.jpg' + '?v=' + FJVersionConfig.staticPathVersion,
        },
        jumpLink: aiToolsPreJumpLink + 'text-to-image/',
    },

    {
        name: 'image-to-image',
        desc: 'transform-images-into-different-styles',
        hoverEffect: 'play video',
        source: {
            normal: simpleToolsSourceBaseUrl + 'image-to-image.png' + '?v=' + FJVersionConfig.staticPathVersion,
            hover: simpleToolsSourceBaseUrl + 'image-to-image.mp4' + '?v=' + FJVersionConfig.staticPathVersion,
        },
        jumpLink: aiToolsPreJumpLink + 'image-to-image/',
    },
    {
        name: 'ai-photo-editor',
        desc: 'edit-images-freely-using-text-prompts',
        hoverEffect: 'play video',

        source: {
            normal: simpleToolsSourceBaseUrl + 'ai-photo-editor.png' + '?v=' + FJVersionConfig.staticPathVersion,
            hover: simpleToolsSourceBaseUrl + 'ai-photo-editor.mp4' + '?v=' + FJVersionConfig.staticPathVersion,
        },
        jumpLink: aiToolsPreJumpLink + 'photo-editor/',
    },
];
export const AI_TOOLS_RESOURCE_PATH =
    FJConfig.serverPath + FJConfig.resourcePath.replace('/', '') + 'community/ai-tools/';

export const COMMUNITY_COVER_IMAGE_PATH = FJS3Config.S3_SERVER_HOST + 'ai/export/community/thumbnail/';
export const COMMUNITY_COVER_VIDEO_PATH = FJS3Config.S3_SERVER_HOST + 'ai/export/community/';
export const AI_COMMUNITY_AI_TOOLS_DATA = [
    {
        category: 'popular',
        isHot: true,
        list: [
            {
                name: 'ai-image-to-video',
                source: [
                    'ai-image-to-video.png?v=' + FJVersionConfig.staticPathVersion,
                    'ai-image-to-video.mp4?v=' + FJVersionConfig.staticPathVersion,
                ],
                hoverEffect: 'play video',
                jumpLink: aiToolsPreJumpLink + 'video-generator/image-to-video/',
            },
            {
                name: 'ai-text-to-video',
                source: [
                    'ai-text-to-video.png?v=' + FJVersionConfig.staticPathVersion,
                    'ai-text-to-video.mp4?v=' + FJVersionConfig.staticPathVersion,
                ],
                hoverEffect: 'play video',
                jumpLink: aiToolsPreJumpLink + 'video-generator/text-to-video/',
            },
            {
                name: 'ai-photo-editor',
                source: [
                    'ai-photo-editor.png?v=' + FJVersionConfig.staticPathVersion,
                    'ai-photo-editor.mp4?v=' + FJVersionConfig.staticPathVersion,
                ],
                hoverEffect: 'play video',
                jumpLink: aiToolsPreJumpLink + 'photo-editor/',
            },
            {
                name: 'ai-text-to-image',
                source: ['text-to-image.png?v=' + FJVersionConfig.staticPathVersion],
                hoverEffect: 'zoom in',
                jumpLink: aiToolsPreJumpLink + 'text-to-image/',
            },

            {
                name: 'ai-image-to-image',
                source: [
                    'image-to-image.png?v=' + FJVersionConfig.staticPathVersion,
                    'image-to-image.mp4?v=' + FJVersionConfig.staticPathVersion,
                ],
                hoverEffect: 'play video',
                jumpLink: aiToolsPreJumpLink + 'image-to-image/',
            },

            {
                name: 'ai-old-photo-restoration',
                source: [
                    'ai-old-photo-restoration-before.png?v=' + FJVersionConfig.staticPathVersion,
                    'ai-old-photo-restoration-after.png?v=' + FJVersionConfig.staticPathVersion,
                ],
                hoverEffect: 'compare',
                jumpLink: aiToolsPreJumpLink + 'old-photo-restoration/',
            },
            {
                name: 'ai-headshot-generator',
                source: ['ai-headshot-generator.png?v=' + FJVersionConfig.staticPathVersion],
                hoverEffect: 'zoom in',
                jumpLink: aiToolsPreJumpLink + 'headshot-generator/',
            },
        ],
    },
    {
        category: 'image',
        isHot: false,
        list: [
            {
                name: 'ai-photo-editor',
                source: [
                    'ai-photo-editor.png?v=' + FJVersionConfig.staticPathVersion,
                    'ai-photo-editor.mp4?v=' + FJVersionConfig.staticPathVersion,
                ],
                hoverEffect: 'play video',
                jumpLink: aiToolsPreJumpLink + 'photo-editor/',
            },
            {
                name: 'ai-image-to-image',
                source: [
                    'image-to-image.png?v=' + FJVersionConfig.staticPathVersion,
                    'image-to-image.mp4?v=' + FJVersionConfig.staticPathVersion,
                ],
                hoverEffect: 'play video',
                jumpLink: aiToolsPreJumpLink + 'image-to-image/',
            },
            {
                name: 'ai-text-to-image',
                source: ['text-to-image.png?v=' + FJVersionConfig.staticPathVersion],
                hoverEffect: 'zoom in',
                jumpLink: aiToolsPreJumpLink + 'text-to-image/',
            },
            {
                name: 'ai-image-bg-remover',
                source: [
                    'image-background-remover-before.png?v=' + FJVersionConfig.staticPathVersion,
                    'image-background-remover-after.png?v=' + FJVersionConfig.staticPathVersion,
                ],
                hoverEffect: 'compare',
                jumpLink: aiToolsPreJumpLink + 'image-background-remover/',
            },
            {
                name: 'ai-old-photo-restoration',
                source: [
                    'ai-old-photo-restoration-before.png?v=' + FJVersionConfig.staticPathVersion,
                    'ai-old-photo-restoration-after.png?v=' + FJVersionConfig.staticPathVersion,
                ],
                hoverEffect: 'compare',
                jumpLink: aiToolsPreJumpLink + 'old-photo-restoration/',
            },

            {
                name: 'ai-object-eraser',
                source: [
                    'ai-object-remover.png?v=' + FJVersionConfig.staticPathVersion,
                    'ai-object-remover.mp4?v=' + FJVersionConfig.staticPathVersion,
                ],
                hoverEffect: 'play video',
                jumpLink: aiToolsPreJumpLink + 'object-remover/',
            },

            {
                name: 'ai-face-swap',
                source: [
                    'ai-face-swap.png?v=' + FJVersionConfig.staticPathVersion,
                    'ai-face-swap.mp4?v=' + FJVersionConfig.staticPathVersion,
                ],
                hoverEffect: 'play video',
                jumpLink: aiToolsPreJumpLink + 'face-swap/',
            },
            {
                name: 'ai-image-extender',
                source: [
                    'ai-image-extender.png?v=' + FJVersionConfig.staticPathVersion,
                    'ai-image-extender.mp4?v=' + FJVersionConfig.staticPathVersion,
                ],
                hoverEffect: 'play video',
                jumpLink: aiToolsPreJumpLink + 'image-extender/',
            },
            {
                name: 'ai-image-upscaler',
                source: [
                    'ai-image-upscaler-before.png?v=' + FJVersionConfig.staticPathVersion,
                    'ai-image-upscaler-after.png?v=' + FJVersionConfig.staticPathVersion,
                ],
                hoverEffect: 'compare',
                jumpLink: aiToolsPreJumpLink + 'image-upscaler/',
            },
            {
                name: 'ai-photo-colorizer',
                source: [
                    'ai-photo-colorize-before.png?v=' + FJVersionConfig.staticPathVersion,
                    'ai-photo-colorize-after.png?v=' + FJVersionConfig.staticPathVersion,
                ],
                hoverEffect: 'compare',
                jumpLink: aiToolsPreJumpLink + 'photo-colorizer/',
            },
            {
                name: 'ai-clothes-changer',
                source: [
                    'ai-clothes-changer-before.png?v=' + FJVersionConfig.staticPathVersion,
                    'ai-clothes-changer-after.png?v=' + FJVersionConfig.staticPathVersion,
                ],
                hoverEffect: 'compare',
                jumpLink: aiToolsPreJumpLink + 'clothes-changer/',
            },
            {
                name: 'ai-hairstyle-changer',
                source: [
                    'ai-hairstyle-changer-before.png?v=' + FJVersionConfig.staticPathVersion,
                    'ai-hairstyle-changer-after.png?v=' + FJVersionConfig.staticPathVersion,
                ],
                hoverEffect: 'compare',
                jumpLink: aiToolsPreJumpLink + 'hairstyle-changer/',
            },
            {
                name: 'ai-watermark-remover',
                source: [
                    'watermark-remover-before.png?v=' + FJVersionConfig.staticPathVersion,
                    'watermark-remover-after.png?v=' + FJVersionConfig.staticPathVersion,
                ],
                hoverEffect: 'compare',
                jumpLink: aiToolsPreJumpLink + 'watermark-remover/',
            },

            {
                name: 'ai-headshot-generator',
                source: ['ai-headshot-generator.png?v=' + FJVersionConfig.staticPathVersion],
                hoverEffect: 'zoom in',
                jumpLink: aiToolsPreJumpLink + 'headshot-generator/',
            },
        ],
    },
    {
        category: 'video',
        isHot: false,
        list: [
            {
                name: 'ai-image-to-video',
                source: [
                    'ai-image-to-video.png?v=' + FJVersionConfig.staticPathVersion,
                    'ai-image-to-video.mp4?v=' + FJVersionConfig.staticPathVersion,
                ],
                hoverEffect: 'play video',
                jumpLink: aiToolsPreJumpLink + 'video-generator/image-to-video/',
            },
            {
                name: 'ai-text-to-video',
                source: [
                    'ai-text-to-video.png?v=' + FJVersionConfig.staticPathVersion,
                    'ai-text-to-video.mp4?v=' + FJVersionConfig.staticPathVersion,
                ],
                hoverEffect: 'play video',
                jumpLink: aiToolsPreJumpLink + 'video-generator/text-to-video/',
            },
            {
                name: 'ai-video-effect',
                source: [
                    'video-effect.png?v=' + FJVersionConfig.staticPathVersion,
                    'video-effect.mp4?v=' + FJVersionConfig.staticPathVersion,
                ],
                hoverEffect: 'play video',
                jumpLink: aiToolsPreJumpLink + 'video-generator/video-effect/',
            },
            {
                name: 'ai-auto-subtitle',
                source: ['ai-auto-subtitle.png?v=' + FJVersionConfig.staticPathVersion],
                hoverEffect: 'zoom in',
                jumpLink: 'editor/app?module=subtitle',
            },
            {
                name: '3d-photo-animation',
                source: [
                    'ai-3d-photo-animation.png?v=' + FJVersionConfig.staticPathVersion,
                    'ai-3d-photo-animation.mp4?v=' + FJVersionConfig.staticPathVersion,
                ],
                hoverEffect: 'play video',
                jumpLink: aiToolsPreJumpLink + '3d-photo-animation/',
            },
            {
                name: 'ai-video-script',
                source: ['ai-video-script.png?v=' + FJVersionConfig.staticPathVersion],
                hoverEffect: 'zoom in',
                jumpLink: 'editor/app?tools=ai-script',
            },
            {
                name: 'ai-video-bg-remover',
                source: [
                    'ai-background-remover-before.mp4?v=' + FJVersionConfig.staticPathVersion,
                    'ai-background-remover-after.mp4?v=' + FJVersionConfig.staticPathVersion,
                ],
                hoverEffect: 'compare',
                sourceType: 'video',
                jumpLink: aiToolsPreJumpLink + 'video-background-remover/',
            },
            {
                name: 'ai-text-based-editing',
                source: ['ai-text-based-editing.png?v=' + FJVersionConfig.staticPathVersion],
                hoverEffect: 'zoom in',
                jumpLink: aiToolsPreJumpLink + 'ai-text-based-editing/',
            },
            {
                name: 'ai-video-dub',
                source: ['ai-video-dub.png?v=' + FJVersionConfig.staticPathVersion],
                hoverEffect: 'zoom in',
                jumpLink: aiToolsPreJumpLink + 'video-to-ai-sfx-generator/',
            },
        ],
    },
    {
        category: 'audio',
        isHot: false,
        list: [
            {
                name: 'ai-music-generator',
                source: ['ai-music-generator.png?v=' + FJVersionConfig.staticPathVersion],
                hoverEffect: 'zoom in',
                jumpLink: aiToolsPreJumpLink + 'music-generator/',
            },
            {
                name: 'ai-text-to-speech',
                source: ['ai-text-to-speech.png?v=' + FJVersionConfig.staticPathVersion],
                hoverEffect: 'zoom in',
                jumpLink: 'editor/app?tools=text-to-speech',
            },
            {
                name: 'ai-translator',
                source: ['ai-translator.png?v=' + FJVersionConfig.staticPathVersion],
                hoverEffect: 'zoom in',
                jumpLink: 'editor/app?module=translate',
            },
            {
                name: 'ai-audio-to-audio',
                source: ['ai-audio-to-audio.png?v=' + FJVersionConfig.staticPathVersion],
                hoverEffect: 'zoom in',
                jumpLink: 'editor/app?module=translate-media-to-audio',
            },
            {
                name: 'ai-audio-noise-reducer',
                source: ['ai-audio-noise-reducer.png?v=' + FJVersionConfig.staticPathVersion],
                hoverEffect: 'zoom in',
                jumpLink: 'editor/app?module=ai-noise-reducer',
            },
            {
                name: 'ai-vocal-remover',
                source: ['ai-vocal-remover.png?v=' + FJVersionConfig.staticPathVersion],
                hoverEffect: 'zoom in',
                jumpLink: 'editor/app?module=ai-vocal-remover',
            },
            {
                name: 'ai-sound-effect',
                source: ['ai-sound-effect.png?v=' + FJVersionConfig.staticPathVersion],
                hoverEffect: 'zoom in',
                jumpLink: aiToolsPreJumpLink + 'music-generator/?tab_type=sfx',
            },
            {
                name: 'ai-voice-cloning',
                source: ['ai-voice-clone.png?v=' + FJVersionConfig.staticPathVersion],
                hoverEffect: 'zoom in',
                jumpLink: aiToolsPreJumpLink + 'voice-cloning/',
            },
        ],
    },
];
export const PAGE_LIMIT = 30;
export const MY_SPACE_TAB_LIST = [
    {
        type: FJConstant.MY_CREATIONS,
        text: 'creations',
    },
    {
        type: FJConstant.SHARED_CREATIONS,
        text: 'shared-creations',
    },
    {
        type: FJConstant.LIKED_CREATIONS,
        text: 'like',
    },
];
// const AI_SFX_HISTORY_TYPE = [21];
const AI_AUDIO_HISTORY_TYPE = [17, 21, 29];
const AI_VIDEO_HISTORY_TYPE = [14, 28];
const AI_VIDEO_DUB_HISTORY_TYPE = [25];
const AI_VIDEO_REMOVED_HISTORY_TYPE = [18];
const AI_IMAGE_TO_IMAGE_HISTORY_TYPE = [3];
const AI_TEXT_TO_IMAGE_HISTORY_TYPE = [6];
const AI_IMAGE_REMOVED_HISTORY_TYPE = [15];
const AI_CLOTHES_CHANGER_HISTORY_TYPE = [10];
const AI_FACE_SWAP_HISTORY_TYPE = [11];
const AI_OBJECT_REMOVER_HISTORY_TYPE = [12];
const AI_WATERMARK_HISTORY_TYPE = [33];
const AI_HAIRSTYLE_CHANGER_HISTORY_TYPE = [32];
const AI_PHOTO_EDITOR_HISTORY_TYPE = [36];
const AI_IMAGE_UPSCALER_HISTORY_TYPE = [5];
const AI_OLD_IMAGE_HISTORY_TYPE = [4];
const AI_IMAGE_EXTENDER_HISTORY_TYPE = [9];
export const SUPPORT_COMMUNITY_JOB_TYPE = [
    ...AI_VIDEO_HISTORY_TYPE,
    ...AI_TEXT_TO_IMAGE_HISTORY_TYPE,
    ...AI_IMAGE_TO_IMAGE_HISTORY_TYPE,
    ...AI_PHOTO_EDITOR_HISTORY_TYPE,
];
export const SUPPORT_COMMUNITY_APP_TYPE = [
    FJAppConstant.AI_VIDEO_GENERATOR,
    FJAppConstant.AI_VIDEO_EFFECT,
    FJAppConstant.AI_PHOTO_EDITOR,
    FJAppConstant.TEXT_TO_IMAGE,
    FJAppConstant.IMAGE_TO_IMAGE,
];
export const SUPPORT_COMMUNITY_TOOL_KEY = [
    'ai-video-generator-1',
    'image-to-image',
    'text-to-image',
    'ai-photo-editor',
    'ai-video-generator',
    'ai-effects-video',
];
export const AI_TYPE_IN_MEDIA = [
    ...AI_VIDEO_HISTORY_TYPE,
    ...AI_TEXT_TO_IMAGE_HISTORY_TYPE,
    ...AI_IMAGE_TO_IMAGE_HISTORY_TYPE,
    ...AI_IMAGE_REMOVED_HISTORY_TYPE,
    ...AI_CLOTHES_CHANGER_HISTORY_TYPE,
    ...AI_FACE_SWAP_HISTORY_TYPE,
    ...AI_OBJECT_REMOVER_HISTORY_TYPE,
    ...AI_WATERMARK_HISTORY_TYPE,
    ...AI_HAIRSTYLE_CHANGER_HISTORY_TYPE,
    ...AI_PHOTO_EDITOR_HISTORY_TYPE,
    ...AI_IMAGE_UPSCALER_HISTORY_TYPE,
    ...AI_OLD_IMAGE_HISTORY_TYPE,
    ...AI_IMAGE_EXTENDER_HISTORY_TYPE,
    ...AI_VIDEO_DUB_HISTORY_TYPE,
    ...AI_VIDEO_REMOVED_HISTORY_TYPE,
];
// 工具key 对应的文案的key
export const AI_TYPE_KEY_TO_TEXT_KEY = {
    'ai-video-generator-1': 'video-generator',
    'image-to-image': 'image-to-image-new',
    'text-to-image': 'ai-text-to-image-photo-in',
    'text-to-speech': 'text-to-speech-new',
    'ai-effects-video': 'video-effects',
    'ai-video-generator': 'video-creator',
    'ai-video-bg-remover': 'video-bg-remover',
    'ai-text-based-editing': 'text-based-editing',
    'auto-ai-subtitle': 'auto-subtitles',
    'ai-video-dub': 'video-sfx',
    'video-script': 'video-script-new',
    '3d-photo-animation': '3d-animation',
    'ai-old-photo-restoration': 'photo-restoration',
    'ai-photo-editor': 'photo-editor',
    'ai-object-removal': 'object-removal',
    'ai-face-swap': 'face-swap',
    'ai-image-extender': 'image-extender',
    'ai-image-upscaler': 'image-upscaler',
    'ai-photo-colorizer': 'photo-colorizer',
    'ai-remove-background': 'image-bg-remover',
    'clothes-changer': 'clothes-changer-new',
    'ai-hairstyle-changer': 'hairstyle-changer',
    'ai-watermark-remover': 'watermark-remover',
    'ai-music-generator': 'music-generator',
    'ai-sound-effect': 'sound-effect',
    'ai-translator': 'ai-translator',
    'translate-audio-to-audio-tool': 'ai-dubbing',
    'record-voice': 'record-voice',
    'record-video': 'record-video',
    'giphy-text-tool': 'giphy-text-tool',
};
export const AI_KEY_TO_AI_TYPE = {
    'ai-music-generator': AI_AUDIO_HISTORY_TYPE.join(','),
    'ai-video-generator-1': AI_VIDEO_HISTORY_TYPE.join(','),
    'ai-video-dub': AI_VIDEO_DUB_HISTORY_TYPE.join(','),
    'ai-video-bg-remover': AI_VIDEO_REMOVED_HISTORY_TYPE.join(','),
    'image-to-image': AI_IMAGE_TO_IMAGE_HISTORY_TYPE.join(','),
    'text-to-image': AI_TEXT_TO_IMAGE_HISTORY_TYPE.join(','),
    'ai-remove-background': AI_IMAGE_REMOVED_HISTORY_TYPE.join(','),
    'clothes-changer': AI_CLOTHES_CHANGER_HISTORY_TYPE.join(','),
    'ai-face-swap': AI_FACE_SWAP_HISTORY_TYPE.join(','),
    'ai-object-removal': AI_OBJECT_REMOVER_HISTORY_TYPE.join(','),
    'ai-watermark-remover': AI_WATERMARK_HISTORY_TYPE.join(','),
    'ai-hairstyle-changer': AI_HAIRSTYLE_CHANGER_HISTORY_TYPE.join(','),
    'ai-photo-editor': AI_PHOTO_EDITOR_HISTORY_TYPE.join(','),
    'ai-image-upscaler': AI_IMAGE_UPSCALER_HISTORY_TYPE.join(','),
    'ai-old-photo-restoration': AI_OLD_IMAGE_HISTORY_TYPE.join(','),
    'ai-image-extender': AI_IMAGE_EXTENDER_HISTORY_TYPE.join(','),
};
export const AI_TYPE_TO_TOOL_KEY = {};
AI_TYPE_TO_TOOL_KEY[AI_AUDIO_HISTORY_TYPE.join(',')] = 'ai-music-generator';
AI_TYPE_TO_TOOL_KEY[AI_VIDEO_HISTORY_TYPE.join(',')] = 'ai-video-generator-1';
AI_TYPE_TO_TOOL_KEY[AI_VIDEO_DUB_HISTORY_TYPE.join(',')] = 'ai-video-dub';
AI_TYPE_TO_TOOL_KEY[AI_VIDEO_REMOVED_HISTORY_TYPE.join(',')] = 'ai-video-bg-remover';
AI_TYPE_TO_TOOL_KEY[AI_IMAGE_TO_IMAGE_HISTORY_TYPE.join(',')] = 'image-to-image';
AI_TYPE_TO_TOOL_KEY[AI_TEXT_TO_IMAGE_HISTORY_TYPE.join(',')] = 'text-to-image';
AI_TYPE_TO_TOOL_KEY[AI_IMAGE_REMOVED_HISTORY_TYPE.join(',')] = 'ai-remove-background';
AI_TYPE_TO_TOOL_KEY[AI_CLOTHES_CHANGER_HISTORY_TYPE.join(',')] = 'clothes-changer';
AI_TYPE_TO_TOOL_KEY[AI_FACE_SWAP_HISTORY_TYPE.join(',')] = 'ai-face-swap';
AI_TYPE_TO_TOOL_KEY[AI_OBJECT_REMOVER_HISTORY_TYPE.join(',')] = 'ai-object-removal';
AI_TYPE_TO_TOOL_KEY[AI_WATERMARK_HISTORY_TYPE.join(',')] = 'ai-watermark-remover';
AI_TYPE_TO_TOOL_KEY[AI_HAIRSTYLE_CHANGER_HISTORY_TYPE.join(',')] = 'ai-hairstyle-changer';
AI_TYPE_TO_TOOL_KEY[AI_PHOTO_EDITOR_HISTORY_TYPE.join(',')] = 'ai-photo-editor';
AI_TYPE_TO_TOOL_KEY[AI_IMAGE_UPSCALER_HISTORY_TYPE.join(',')] = 'ai-image-upscaler';
AI_TYPE_TO_TOOL_KEY[AI_OLD_IMAGE_HISTORY_TYPE.join(',')] = 'ai-old-photo-restoration';
AI_TYPE_TO_TOOL_KEY[AI_IMAGE_EXTENDER_HISTORY_TYPE.join(',')] = 'ai-image-extender';
export const SKELETON_SCREEN_LIST = [
    {
        id: 'skeleton-screen-1',
        width: 400,
        height: 530,
    },
    {
        id: 'skeleton-screen-2',
        width: 400,
        height: 400,
    },
    {
        id: 'skeleton-screen-3',
        width: 400,
        height: 300,
    },
    {
        id: 'skeleton-screen-4',
        width: 400,
        height: 230,
    },

    {
        id: 'skeleton-screen-5',
        width: 400,
        height: 220,
    },
    {
        id: 'skeleton-screen-6',
        width: 400,
        height: 530,
    },
    {
        id: 'skeleton-screen-7',
        width: 400,
        height: 400,
    },
    {
        id: 'skeleton-screen-8',
        width: 400,
        height: 300,
    },

    {
        id: 'skeleton-screen-9',
        width: 400,
        height: 230,
    },
    {
        id: 'skeleton-screen-10',
        width: 400,
        height: 220,
    },
    {
        id: 'skeleton-screen-11',
        width: 400,
        height: 530,
    },
    {
        id: 'skeleton-screen-12',
        width: 400,
        height: 400,
    },
    {
        id: 'skeleton-screen-13',
        width: 400,
        height: 300,
    },
    {
        id: 'skeleton-screen-14',
        width: 400,
        height: 230,
    },
    {
        id: 'skeleton-screen-15',
        width: 400,
        height: 220,
    },
    {
        id: 'skeleton-screen-16',
        width: 400,
        height: 220,
    },
];

export const MY_SPACE_SKELETON_SCREEN_LIST = [
    [
        {
            width: 298,
            height: 168,
        },
        {
            width: 298,
            height: 168,
        },
        {
            width: 298,
            height: 168,
        },
        {
            width: 298,
            height: 168,
        },
        {
            width: 298,
            height: 168,
        },
        {
            width: 298,
            height: 168,
        },
    ],
    [
        {
            width: 298,
            height: 168,
        },
        {
            width: 298,
            height: 168,
        },
        {
            width: 298,
            height: 168,
        },
        {
            width: 298,
            height: 168,
        },
        {
            width: 298,
            height: 168,
        },
        {
            width: 298,
            height: 168,
        },
    ],
    [
        {
            width: 298,
            height: 168,
        },
        {
            width: 298,
            height: 168,
        },
        {
            width: 298,
            height: 168,
        },
        {
            width: 298,
            height: 168,
        },
        {
            width: 298,
            height: 168,
        },
        {
            width: 298,
            height: 168,
        },
    ],
];
export const PUBLISH_TYPE = {
    PUBLIC: 'public',
    ONLY_PUBLIC: 'only_public',
    PRIVATE: 'private',
    DOWN: 'down',
};

export const SHARE_SETTING_LIST = [
    {
        name: 'post-to-community',
        value: PUBLISH_TYPE.PUBLIC,
        desc: 'share-your-creation-to-flexclip-ai-community',
    },
    {
        name: 'shareable-link',
        value: PUBLISH_TYPE.ONLY_PUBLIC,
        desc: 'view-via-link-share-on-social',
    },
    {
        name: 'private',
        value: PUBLISH_TYPE.PRIVATE,
        desc: 'only-you-can-view',
    },
];

export const WORK_TYPE_TO_TOOL_PAGE_PATH = {
    3: '/image-to-image/',
    4: '/old-photo-restoration/',
    5: '/image-upscaler/',
    6: '/text-to-image/',
    9: '/image-extender/',
    10: '/clothes-changer/',
    11: '/face-swap/',
    12: '/object-remover/',
    14: '/video-generator/',
    15: '/image-background-remover/',
    17: '/music-generator/',
    18: '/video-background-remover/',
    21: '/music-generator/',
    25: '/video-to-ai-sfx-generator/',
    28: '/video-generator/video-effect/',
    29: '/music-generator/',
    32: '/hairstyle-changer/',
    36: '/photo-editor/',
};

export const AI_COMMUNITY_TYPES = {
    TREND: 'trend',
    VIDEO: 'video',
    IMAGES: 'images',
};
export const COMMUNITY_WORKS_TYPE = {
    WORKS: 'works',
    ADVERTISING: 'advertising',
    TEMPLATE: 'template',
};
export const COMMUNITY_SORT_TYPE = [
    {
        name: 'default',
        value: 'default',
        icon: FJNewestIcon,
    },
    {
        name: 'newest',
        value: 'latest',
        icon: FJNewestIcon,
    },
];
